export const SCROLLBAR_POSITION = ['outside', 'inside'] // inside outside
export const VERTICAL_SCROLL_BAR_LAYOUT = 'vertical'
export const HORIZONTAL_SCROLL_BAR_LAYOUT = 'horizontal'



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/config/constant.js